import { CLASS_TYPES } from '../data/classTypes';
import hasContestLesson from './hasContestLesson';
import hasLiveLecture from './hasLiveLecture';

function parseAcademyTopicClassType(academyTopic) {
  // For those cases in which `academyTopic` does not have lessons included
  // in their response
  if (!academyTopic?.lessons) return null;

  if (hasContestLesson(academyTopic.lessons)) {
    return CLASS_TYPES.contest;
  } else if (!hasLiveLecture(academyTopic.lessons)) {
    return CLASS_TYPES.classWithoutLiveLecture;
  } else {
    return CLASS_TYPES.lecture;
  }
}

export default parseAcademyTopicClassType;
